class Shot {
	public targetPosition: PIXI.Point;
	public targetMobs: Array<Mob> = [];
}